import React, { useState, useEffect } from 'react';
import { Button, TextInput } from 'carbon-components-react';
import  Delete  from 'assets/image/Delete.svg';
import { Add16 } from "@carbon/icons-react";

require("./_add-parameter.scss");

const AddParameter = (props) => {

    const [inputList, setInputList] = useState([{ Name: "", Type:"", Value:"" }]);

    useEffect(() => {
    }, [props.showAddParameter,props.parameterNotAvailableOnlyDuration, props.parameterlength]);

    // handle input change
    const handleInputChange = (e, index) => {
        const { id, value } = e.target;
        const list = [...inputList];
        list[index][id] = value;
        setInputList(list);
    };

    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
        if(inputList.length === 1){
            props.updateState("parameterNotAvailableOnlyDuration",false);
            props.updateState("showAddParameter",false);
            props.updateState("parameterlength",0);
            
        }
    };

    // handle click event of the Add button
    const handleAddClick = () => {
        setInputList([...inputList, { Name: "", Type:"", Value:"" }]);
    };

    return (
        <div className="add-parameter-container">
            {inputList.map((x, i) => {
                return (
                    <div>
                        <div className="parameters-inputs  margin-top-10px">
                        <div className="margin-left-20px">Parameter {i+1}</div>
                        </div>
                        {inputList.length ?
                        <div className="icon-del">
                         <img src={Delete}
                                onClick={() => handleRemoveClick(i)}></img>
                        </div>:null}
                        <div className="parameters-inputs margin-left-20px">
                        
                            <div className="parameters-input">
                                <TextInput
                                    id="Name"
                                    labelText={"Name"}
                                    placeholder="name"
                                    //value={x.Name}
                                    onChange={e => handleInputChange(e, i)}
                                />
                            </div>
                             <div className="parameters-input">
                                <TextInput
                                    id="Type"
                                    labelText={"Type"}
                                    placeholder="type"
                                    //value={x.Type}
                                    onChange={e => handleInputChange(e, i)}
                                />
                            </div>
                            <div className="parameters-input">
                                <TextInput
                                    id="Value"
                                    labelText={"Value"}
                                    placeholder="value"
                                    //value={x.Value}
                                    onChange={e => handleInputChange(e, i)}
                                />
                            </div> 
                        </div>
                        <div className="add-more-param">
                            
                            {inputList.length - 1 === i && <Button renderIcon={Add16} onClick={handleAddClick}>Add More Param</Button>}
                        </div>
                    </div>
                );
            })}
            {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
        </div>
    );
};

export default AddParameter;
